const env = process.env;
export default {
    baseUrl: env.VUE_APP_BASE_URL,
    socketUrl: env.VUE_APP_SOCKET_URL
}
